import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import { IHouseStats } from '../../../../types/newbuilding/genplan';
import { Link } from '../../../Link';

import * as styles from './styles.css';

interface IHouseStatsProps extends IHouseStats {
  houseId: number;
  onLinkClick(houseId: number, rooms?: string): void;
}

export function HouseStats({
  houseId,
  fromDeveloperPropsCountUrl,
  fromDeveloperPropsCountDisplay,
  fromDeveloperRooms,
  onLinkClick,
}: IHouseStatsProps) {
  return (
    <>
      {fromDeveloperRooms.map(({ roomTypeDisplay, price2From, offersUrl, roomType }) => (
        <Link
          key={roomTypeDisplay}
          url={offersUrl}
          target="blank"
          linkStyle={styles['room-link']}
          onClick={() => onLinkClick(houseId, roomType)}
        >
          <UIText2 fontWeight="bold">{roomTypeDisplay}</UIText2>
          <UIText2>{price2From}</UIText2>
        </Link>
      ))}
      <Link
        url={fromDeveloperPropsCountUrl}
        target="blank"
        linkStyle={styles['link']}
        onClick={() => onLinkClick(houseId)}
      >
        <UIText2 color="text-main-default">{fromDeveloperPropsCountDisplay}</UIText2>
      </Link>
    </>
  );
}
